// @flow

import React from 'react'
import { renderToString } from 'react-dom/server';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bindAll from 'lodash/bindAll'
import { List, Map, fromJS } from 'immutable'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import moment from 'moment'
import PaginationSupport from '../partials/PaginationSupport'
import $ from 'jquery'

import {
	assessmentGetDetail,
	assessmentsAddFilterPageNumber,
	assessmentsAddFilterSearch,
	companiesAddFilterSort,
	companiesAddFilterName,
	assessmentsAddFilterColPerPage,
	companiesAddFilterStatus,
	assessmentsVersionClearFilterData,
	companiesAddFilterChannel,
  assessmentsVersionAddFilterAssessmentName,
	assessmentVersionRollback,
	assessmentVersionUpdate,
} from '../../actions/assessment'

import{
  globalAddSweetAlertData,
	globalHideSweetAlert,
} from '../../actions/global'

import ModalDownloadAllAccounts from '../partials/ModalDownloadAllAccounts'
import ModalConnectPopskul from '../partials/ModalConnectPopskul'

import TableLoader from '../partials/TableLoader'

require('es6-promise').polyfill()

type Props = {
	assessmentGetDetail: Function,
	assessmentGetDetailAsync: Function,
	assessmentsPagination: Map<string, any>,
	companies: List<Map<string, any>>,
	companiesFilterData: Map<string, any>,
	assessmentsAddFilterPageNumber: Function,
	globalIndicatorData: Map<string, any>,
	assessmentsAddFilterSearch: Function,
	companiesAddFilterSort: Function,
	companiesAddFilterName: Function,
	assessmentsAddFilterColPerPage: Function,
	companiesAddFilterStatus: Function,
	companiesAddFilterChannel: Function,
};

type State = {
	isShown: boolean
};

function formatCompetencyName(name) {
 const mapping = {
    analytical_thinking: 'Total Analytical Thinking',
    'creative-thinking': 'Creative Thinking',
    
  };

		if (mapping[name]) {
			return mapping[name];
		}

  	// For other snake_case names, convert to Capitalized Words
		if (typeof name === 'string' && name.includes('_')) {
			return name
				.split('_')
				.map(word => word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : '')
				.join(' ');
		}

		// Capitalize first letter for other cases
		if (typeof name === 'string' && name.length > 0) {
			return name.charAt(0).toUpperCase() + name.slice(1);
		}

		return name;
}

class AssessmentVersionDetail extends React.Component<Props, State> {
	state: State;

	constructor(props) {
		super(props)

		this.state = {
			isShown: false,
			selectedCompany:{}
		}

		bindAll(this, [
			'handleSortChange',
			'handleSearchByName',
			'handleChangePageSize',
			'handleFilterByStatus',
			'handleModalDownload',
			'creditFormatter',
			'titleFormatter',
			'handleSelectRow',
			'dateFormatter',
			'popskulActionFormater',
			'handleConnectDisconnectPopskul',
			'onCloseModal',
      'statusFormatter',
      'handleUpdateNorm',
		])
	}

  handleUpdateNorm(isUpdate){
    const{
      globalAddSweetAlertData,
      globalHideSweetAlert,
			assessmentVersionUpdate,
			assessmentVersionRollback,
			assessment_name,
    }=this.props;
    if (isUpdate) {
        globalAddSweetAlertData({
          show: true,
          showCancelButton: true,
          customClass: 'swal-support',
          confirmButtonColor: '#564FDB',
          confirmButtonText: 'Update',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          title: `Update Norm Score?`,
          text: "Are you sure to update the norm score? This process runs in the background, so feel free to navigate away and work on other tasks. We'll notify you once it's complete.",
          onConfirm: () => {

						assessmentVersionUpdate(assessment_name)
            globalHideSweetAlert()
          },
          onCancel: () => {
						
            globalHideSweetAlert()
          }
        })
    }else{
       globalAddSweetAlertData({
          show: true,
          showCancelButton: true,
          customClass: 'swal-support',
          confirmButtonColor: '#EA4D4D',
          confirmButtonText: 'Rollback',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          title: `Rollback Normed Score?`,
          text: "Are you sure you want to roll back the normed score? If you proceed, the system will revert to the previous version of the norm score, which may affect your current evaluations.",
          onConfirm: () => {
						assessmentVersionRollback(assessment_name)
            globalHideSweetAlert()
          },
          onCancel: () => {
            globalHideSweetAlert()
          }
        })
    }
  }
  
	statusFormatter(cell: Object, row: Object): Object {
		let colorText='text-detail'
		let status = 'Active'
		
		return <span className={colorText}>{'Lihat Detail'}</span>
	}

	componentDidMount() {
		const {
			assessmentGetDetail,
      assessment_name,
			assessment_id,
		} = this.props
    console.log(assessment_name,'assessment_name')
		let prevState = this.props.location.state
	
		assessmentGetDetail(assessment_id)
       
		
	}

	handleModalDownload(e: Object){
		e.preventDefault()

		$('#modalDownloadAllAccounts').modal('show')
	}

	handleChangePageSize(e): void{
		const{
			assessmentsAddFilterPageNumber,
			assessmentGetDetail,
			assessmentsAddFilterColPerPage,
		}=this.props

		const countFilter = e.target.value
		assessmentsAddFilterPageNumber(1)
		.then(()=>{
			assessmentsAddFilterColPerPage(countFilter)
			.then(()=>{
				assessmentGetDetail(this.props.assessmentsVersionFilterData)
			})
		})

	}

	handleSortChange(name, order){
		const {
			assessmentGetDetail,
			companiesAddFilterSort
		} = this.props

		let sort={
			name: name,
			value: order
		}

		// companiesAddFilterSort(sort).then(()=>assessmentGetDetail(this.props.assessmentsVersionFilterData))

	}

	handleSearchByName(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentGetDetail,
			assessmentsAddFilterSearch
		}=this.props

		let keywords=event.target.value
		if (event.charCode === 13) {
			assessmentsAddFilterPageNumber(1).then(()=>{
				assessmentsAddFilterSearch(keywords).then(()=>{
					assessmentGetDetail(this.props.assessmentsVersionFilterData)
				})
			})
    	}
	}

	handleFilterByStatus(event){
		const{
			assessmentsAddFilterPageNumber,
			assessmentGetDetail,
			companiesAddFilterStatus
		}=this.props

		let status=event.target.value
		assessmentsAddFilterPageNumber(1).then(()=>{
			companiesAddFilterStatus(status).then(()=>{
				assessmentGetDetail(this.props.companiesFilterData)
			})
		})
	}

	creditFormatter(cell: Object, row: Object): Object {
		let colorText='text-red'
		let credit = parseInt(row.candidate_credit);
		let creditUsed = parseInt(row.credit_used);
		let creditText = `${credit-creditUsed}/${creditUsed}`
		if(row.status==='Active'){
			colorText='text-green'
			creditText = row.credit_left;
		}
		return <span className={colorText}>{creditText}</span>
	}

	dateFormatter(cell: Object, row: Object): Object {
		let date = (row.valid_date ? moment(row.valid_date).format("MMM D, YYYY") : '')
		return <span>{date}</span>
	}
	
	handleSelectRow(row, index){
		if(index <=7 ){
			this.props.history.push({ 
				pathname: `/support/university/${row.id}`,
				state: {prevPage: 'company-index'}
			})
		}
	}

	titleFormatter(cell: Object, row: Object): Object {
    const currentVersion = <span className={'text-green'}>(Current Version)</span>
		return <div>
		  <span>v{row.version} </span>
      {row.currently_used?currentVersion:''}
	  </div>						
	}

	purifyData(data,normed_score){
		const jsData = data.toJS(); // convert Immutable to JS object

		const result = Object.entries(jsData).map(([name, values]) => ({
			name: formatCompetencyName(name),
			mean: values.mean,
			standard_deviation: values.standard_deviation
		}));
		
		// Push normed_score data
		if (normed_score && normed_score.get) {
			result.push({
				name: 'Stanine [Normed Score]',
				mean: normed_score.get('mean'),
				standard_deviation: normed_score.get('standard_deviation')
			});
		}

		return result;
	}

	popskulActionFormater(cell, row){
		const {
			userPrivilege, 
			userAuth
		} = this.props

		// let itSelf=userAuth.get('id')==row.id ? true : false
		// let myPrivilege=['UPDATE_USER','ACTIVATE_USER','RESET_USERS_PASSWORD','VISIT_USERS_DASHBOARD','SEND_EMAIL_TO_USERS','DELETE_USERS']
		// let res = userPrivilege.filter(item => myPrivilege.includes(item));
		
		// if(itSelf || res.length<1){
		// 	return null
		// }
		let buttonLabel = 'Connect'
		let buttonClass = 'button__primary'
		console.log('b', row);
		if(row.popskul_connection==1){
			buttonLabel = 'Disconnect'
			buttonClass = 'button__secondary'
		}
		return <button onClick={(e)=>this.handleConnectDisconnectPopskul(e, row)} className={`button ${buttonClass}`}>{buttonLabel}</button>
	}

	handleConnectDisconnectPopskul(e, company){
		e.preventDefault()
		this.setState({selectedCompany:company})
		$('#modalConnectPopskul').modal('show')
	}

	onCloseModal(){
		this.setState({selectedCompany:{}})
		this.props.assessmentGetDetail(this.props.companiesFilterData)
	}

  	render() {
		const {
			companies,
			assessmentsPagination,
			assessmentsAddFilterPageNumber,
			assessmentsVersionFilterData,
			assessmentGetDetail,
			globalIndicatorData,
			assessmentsVersion,
			assessment_name,
			assessment
		} = this.props

		const general_settings = assessment.get('general_settings') || fromJS({});
	
		const norm_calculation_parameter = general_settings.get('norm_calculation_parameter') || fromJS({});
		const normed_score = general_settings.get('normed_score') || fromJS({});
		const isIndicatorClass = globalIndicatorData.get('isShow')? 'p-t-56' : ''
		const options = {
			onSortChange: this.handleSortChange,
			noDataText: <TableLoader isFetched={this.props.isFetched}/>
		};

    let backPath = `/support/assessment-dashboard/${assessment_name}`
    	let prevState = this.props.location.state
      const assessment_title = assessment.get('name')
    	return (

			<div className={isIndicatorClass}>
	      		<div className="div-support-container table">
	        		<section className="wrapper">
	          			<div className="main-content">
	            			<div className="container-fluid">
	              				<div className="big-panel">
                  <div className="flex-container">
											<Link to={{pathname : backPath, state:{prevPage:prevState}}} className="btn-support"><i className="fa fa-angle-left" style={{fontSize: '18px'}}></i> Back to {assessment_title}</Link>
									</div>
									<div className="flex-container">
										<h5 className="title-heading">{assessment_title} v{assessment.get('version')}</h5>
									</div>

									<div className="flex-container flex-between">
										<div className="flex-container detail-assessment-panel vertical-item--center">
											<span>
												Updated at : {moment(assessment.get('created_at')).format('MMM D, YYYY')}
											</span>
											<span>
												Number of Old Data : {assessment.get('old_data_count')}
											</span>
											<span>
												Number of New Data : {assessment.get('new_data_count')}
											</span>
											
										</div>
                     
										
									</div>

	                				<div className="report-list-container assessment-container form-custom support-company-list">
										<BootstrapTable
											data={this.purifyData(norm_calculation_parameter,normed_score)}
											striped={true}
											options={options}
											hover
										>
											<TableHeaderColumn  dataField="name" isKey={true} dataSort={true}>Value/Competency</TableHeaderColumn>
											<TableHeaderColumn dataField="mean" dataSort={true}>Mean</TableHeaderColumn>
											<TableHeaderColumn dataField='standard_deviation' dataSort={true}>Standard Deviation</TableHeaderColumn>
											
										</BootstrapTable>
	                				</div>
	              				</div>
	            			</div>
	          			</div>
	        		</section>
	      		</div>
	      		<ModalDownloadAllAccounts />
				<ModalConnectPopskul company={this.state.selectedCompany} onCloseModal={this.onCloseModal}/>
			</div>
    	)
  	}
}

const mapStateToProps = (state, ownProps) => {
  const assessmentData =fromJS([
    {
      'title':'Value Reflect Assessment(VRA)',
      'updated_at':'2025-04-16 03:38:28',
    },
    {
      'title':'Creative Thinking Assessment(CTA)',
      'updated_at':'2025-03-15 03:38:28'
    }
  ]) 

	return {
		// example
    assessmentData:assessmentData,
		// end of example data
		companies: state.companies,
		companiesFilterData: state.companiesFilterData,
		companiesIsLoading: state.companiesIsLoading,
		globalIndicatorData: state.globalIndicatorData,
		isFetched: state.isFetched,
		assessmentsVersionFilterData:state.assessmentsVersionFilterData,
		assessmentsVersion: state.assessmentsVersion,
		assessmentsPagination:state.assessmentsPagination,
    assessment_name: ownProps.match.params.assessment_name,
     assessment_id: ownProps.match.params.assessment_id,
		 assessment:state.assessment,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		assessmentGetDetail: (assessment_id) => dispatch(assessmentGetDetail(assessment_id)),
		assessmentsAddFilterPageNumber: (page) => dispatch(assessmentsAddFilterPageNumber(page)),
		assessmentsAddFilterSearch: (search) => dispatch(assessmentsAddFilterSearch(search)),
		companiesAddFilterSort: (sort) => dispatch(companiesAddFilterSort(sort)),
		companiesAddFilterName: (name) => dispatch(companiesAddFilterName(name)),
		assessmentsAddFilterColPerPage: (col) => dispatch(assessmentsAddFilterColPerPage(col)),
		companiesAddFilterStatus: (status) => dispatch(companiesAddFilterStatus(status)),
		assessmentsVersionClearFilterData: () => dispatch(assessmentsVersionClearFilterData()),
		companiesAddFilterChannel: (channel) => dispatch(companiesAddFilterChannel(channel)),
    assessmentsVersionAddFilterAssessmentName: (assessment_name)=> dispatch(assessmentsVersionAddFilterAssessmentName(assessment_name)),
    globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
		assessmentVersionUpdate:(assessment_name)=>dispatch(assessmentVersionUpdate(assessment_name)),
		assessmentVersionRollback:(assessment_name)=>dispatch(assessmentVersionRollback(assessment_name)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentVersionDetail)
